var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "records-list"
  }, [_vm.loading ? _c('Loading', {
    attrs: {
      "background-color": '#ffffff',
      "opacity": 0.4
    }
  }) : _vm.expiringPoints.length === 0 ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暫無即將到期點數")]) : _vm._l(_vm.expiringPoints, function (item) {
    return _c('PointCard', {
      key: item.id,
      attrs: {
        "title": _vm.getModuleConfig('member_card_section.points_name') || '點數',
        "date": item.date,
        "date-label": item.date ? '到期日期' : '永久有效',
        "point-need-text": item.point,
        "show-type-info": false
      }
    });
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }